import {Component, Inject, OnInit} from '@angular/core';

import {ComplianceArea} from '../../_models/index';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Bulletin} from "../../_models/bulletin";

@Component({
    standalone: false,
    selector: 'control-item-component',
    templateUrl: 'bulletin.component.html',
    styleUrls: ['./bulletin.component.css'],
})

export class BulletinComponent implements OnInit {
    loading = false;
    bulletin: Bulletin;
    complianceAreas: ComplianceArea[];

    constructor(
      public dialogRef: MatDialogRef<BulletinComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        console.log(this.data.bulletin);

        this.bulletin = Object.assign({}, this.data.bulletin);
      }

    onClose(): void {
        this.dialogRef.close(this.bulletin);
    }
}
